module.exports = __webpack_public_path__ + "media/svg/to-8ca58268.svg";